import Vue from 'vue';
const state = {
    user: {},
    logged: false,
}
const actions = {
    getUser: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/users/me`).then(response => {
                context.commit('LOGGED', true)
                context.commit('GET_USER', response.data.data)
                resolve(response)
            }).catch(error => {
                context.commit('LOGGED', false)
                localStorage.removeItem('token')
                reject(error)
            })
        });
    },
    login: (context, payload) => {

        return new Promise((resolve, reject) => {
            axios.get('/sanctum/csrf-cookie').then(csrf => {
                axios.post(`/api/login`, payload).then(response => {
                    context.commit('LOGGED', true)
                    context.dispatch('getUser');
                    localStorage.setItem('token', response.data.token)
                    Vue.$toast.success("Autenticado com sucesso");
                    resolve(response)
                }).catch(error => {
                    Vue.$toast.error("Falha na autenticação");
                    context.commit('LOGGED', false)
                    reject(error)
                })
            });

        })
    },

    logout: (context) => {
        axios.post(`/api/logout`).then(response => {
            context.commit('LOGGED', false)
            localStorage.removeItem('token')
        })

    }
}
const mutations = {
    GET_USER: (state, payload) => {
        state.user = payload
    },

    LOGGED: (state, status) => {
        state.logged = status
    },

}
const getters = {}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}